<template>
  <v-app>
    <v-app-bar
      app
      color="white"
      flat
    >
      <v-app-bar-nav-icon 
        v-if="$vuetify.breakpoint.md ||
              $vuetify.breakpoint.sm ||
              $vuetify.breakpoint.xs"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-tabs
        class="hidden-md-and-down"
        centered
        color="grey darken-1"
      >
        <v-tab
          class="global-menu-button"
          v-for="link in links"
          :key="link['pageName']"
          @click="onClickMenu(link)"
        >
          <v-icon
            medium
            color="yellow darken-2"
          >
            {{ link['iconPrefix'] }}
          </v-icon>
          {{ link['pageName'] }}
        </v-tab>
      </v-tabs>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      width="212"
      temporary
      fixed
    >
      <v-list
        nav
        dense
      >
        <v-list-item-group>
          <list-item>
            <v-list-title>Toy Box</v-list-title>
            <v-divider></v-divider>
          </list-item>
          <v-list-item
            v-for="link in links"
            :key="link['pageName']"
            retain-focus-on-click
            v-bind:ripple="false"
            @click="onClickMenu(link)"
          >
            <v-list-item-title>
              <v-icon color="yellow darken-2">{{link['iconPrefix']}}</v-icon>{{link['pageName']}}
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-main :class="bgColor">
      <v-container>
        <v-row class="base-row" justify="center">
          <VueBubblyBg
            v-if="relenderAnime"
            class="bg-animation"
            :colorNum="colorNum.toString()"
            :circleNum="circleNum.toString()"
            :circleSize="circleSize"
            :circleSpeed="circleSpeed"
          />
          <v-col
            class="dynamic-page"
            cols="12"
            sm="8"
          >
            <v-sheet
              color="transparent"
              height="100%"
              rounded="lg"
            >
              <router-view></router-view>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<style>
@import "../css/styles.css";
/* .container, .parent-row{ */
  /* position: relative; */
    /* height: 100%;
    width: 100%;
  } */
/* メニューボタンをマウスオーバーした時の背景色の変更を無効化 */
.manu-button::before{
  background-color: transparent;
}
/* pattern1の背景 */
.pattern1-bg{
  background: linear-gradient(60deg, #fff8f0, #fcdaca);
}
/* pattern2の背景 */
.pattern2-bg{
  background: linear-gradient(0deg,  #001e43, #000b1a);
}
/* BubbleBgコンポーネントを再背面に設置 */
.bg-animation{
  z-index: 1;
  position: absolute;
}
/* 動的ページを最前面に設置 */
.dynamic-page{
  z-index: 2;
}
/* v-containerとv-rowの上部スペースを削除 */
.base-row{
  margin: -12px;
}
/* コンテンツの中央寄せのため */
.container, .base-row, dynamic-page{
	height: 100%;
}
</style>

<script>
// import HelloWorld from '../components/HelloWorld';
  import VueBubblyBg from '../components/VueBubblyBg'
  import router from '../router.js'

  export default {
    name: 'App',
    components: {
      // HelloWorld,
      VueBubblyBg,
    },
    data: () => ({
      bgColor: 'pattern1-bg',
      links: [
        {'pageName' : 'Home', 'path': '/home', 'iconPrefix': 'mdi-home'},
        {'pageName' : 'Profile', 'path': '/profile', 'iconPrefix': 'mdi-account'},
        {'pageName' : 'Skill', 'path': '/skill', 'iconPrefix': 'mdi-candycane'},
        {'pageName' : 'Portfolio', 'path': '/portfolio', 'iconPrefix': 'mdi-gift'},
        {'pageName' : 'Social', 'path': '/social', 'iconPrefix': 'mdi-twitter'},
        {'pageName' : 'Contact', 'path': '/contact', 'iconPrefix': 'mdi-cellphone-message'},
      ],
      relenderAnime: true,
      colorNum: 23,
      circleNum: 50,
      circleSpeed: 'slow',
      circleSize: '',
      animationPattern: {
        'pattern1' : 
          {colorNum: 23, circleSize: "", circleNum: 50, circleSpeed: "slow", bgColor: 'pattern1-bg'},
        'pattern2' :
          {colorNum: 40, circleSize: "verysmall", circleNum: 120, circleSpeed: "fast", bgColor: 'pattern2-bg'}
      },
      drawer: false,
    }),
    methods:{
      /**
       * メニューボタンに対応する画面へ遷移。
       * @param {link} クリックしたボタンの名前と遷移先パスが格納された辞書型。
       */
      onClickMenu(link){
        switch(link['pageName']){
          case 'Home':
            if(this.$route.path != '/home'){
              router.push({ path: link['path'] }) 
              // router.push({ path: `/user/${userId}` })
            } 
            break
          case 'Profile':
            if(this.$route.path != '/profile'){
              router.push({ path: link['path'] }) 
            } 
            break
          case 'Skill':
            if(this.$route.path != '/skill'){
              router.push({ path: link['path'] }) 
            } 
            break
          case 'Portfolio':
            if(this.$route.path != '/portfolio'){
              router.push({ path: link['path'] }) 
            } 
            break
          case 'Social':
            if(this.$route.path != '/social'){
              router.push({ path: link['path'] }) 
            } 
            break
          case 'Contact':
            if(this.$route.path != '/contact'){
              router.push({ path: link['path'] }) 
            } 
            break
        }
        // ページ切替後アニメーションを再マウント
        this.relenderAnime = false
        this.$nextTick(() => (this.relenderAnime = true));
      },
      onClickNavIcon(){
        this.drawer = !this.drawer;
        // this.$set(this.draw,true)
        console.log('click');
        console.log(this.drawer);
      },
      onTest(){
        console.log(this.drawer);
      },
      /** 
       * 背景アニメーションのパターンを変更する。 
      */
      changeAnimation(){
      console.log("changeAnimation")
      },
    },
    computed:{
      /* Vuex Store内hiddenBtnFlg変数のgetter */
      getHiddenBtnFlg: function(){
        return this.$store.state.hiddenBtnFlg
      },
    },
    watch:{
      /* Vuex Store内hiddenBtnFlgの状態監視 */
      getHiddenBtnFlg(){
        if(!this.getHiddenBtnFlg){
          this.bgColor = this.animationPattern['pattern1']['bgColor']
          this.colorNum = this.animationPattern['pattern1']['colorNum']
          this.circleNum = this.animationPattern['pattern1']['circleNum']
          this.circleSpeed = this.animationPattern['pattern1']['circleSpeed']
          this.circleSize = this.animationPattern['pattern1']['circleSize']
        }else{
          this.bgColor = this.animationPattern['pattern2']['bgColor']
          this.colorNum = this.animationPattern['pattern2']['colorNum']
          this.circleNum = this.animationPattern['pattern2']['circleNum']
          this.circleSpeed = this.animationPattern['pattern2']['circleSpeed']
          this.circleSize = this.animationPattern['pattern2']['circleSize']
        }
        // bubbleBgコンポーネントの再描画
        this.relenderAnime = false
        this.$nextTick(() => (this.relenderAnime = true));
      },
      // drawer () {
      //   this.drawer = false
      // }
    },
    beforeMount(){
      // nothing
      // this.$set(this.draw,true)
    }
  };
</script>
